import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import Image from '../Image';
import ErrorBoundary from '../ErrorBoundary';
import ProductListItem from '../ProductListItem';
import HouseAd from '../HouseAd';
import css from './CollectionSet.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InlineHeader = function InlineHeader(_ref) {
  var componentType = _ref.componentType,
      description = _ref.description,
      image = _ref.image,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("li", {
    className: cc([css.inlineHeader, css.gridItem, css[componentType]]),
    children: [/*#__PURE__*/_jsx("h2", {
      className: cc([css.title, css.isDesktop]),
      children: title
    }), subtitle && /*#__PURE__*/_jsx("p", {
      className: cc([css.inlineSubTitle, css.isDesktop]),
      children: subtitle
    }), image && image.src && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      className: css.featureImage
    })), description && /*#__PURE__*/_jsx("p", {
      className: cc([css.descriptoin, css.inlineDescription]),
      children: description
    })]
  });
};

InlineHeader.defaultProps = {
  description: '',
  subtitle: ''
};
InlineHeader.propTypes = {
  componentType: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }).isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired
};

var List = function List(_ref2) {
  var displayEditorial = _ref2.displayEditorial,
      displaySwatches = _ref2.displaySwatches,
      gridLayout = _ref2.gridLayout,
      inlineHeader = _ref2.inlineHeader,
      isMobile = _ref2.isMobile,
      products = _ref2.products;
  return /*#__PURE__*/_jsxs("ul", {
    className: cc([css.list, _defineProperty({}, css.grid, gridLayout)]),
    children: [!!inlineHeader && /*#__PURE__*/_jsx(InlineHeader, _objectSpread({}, inlineHeader)), products.edges.map(function (_ref4) {
      var node = _ref4.node;
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [node.component && /*#__PURE__*/_jsx(ErrorBoundary, {
          children: /*#__PURE__*/_jsx(HouseAd, _objectSpread(_objectSpread({}, node.component), {}, {
            isMobile: isMobile
          }))
        }), node.product && /*#__PURE__*/_jsx("li", {
          className: cc([css.item, _defineProperty({}, css.gridItem, gridLayout)]),
          children: /*#__PURE__*/_jsx(ErrorBoundary, {
            children: /*#__PURE__*/_jsx(ProductListItem, _objectSpread(_objectSpread({}, node), {}, {
              displayEditorial: displayEditorial,
              displaySwatches: displaySwatches,
              displayWishListToggle: !node.product.properties.giftCard,
              isMobile: isMobile,
              onPLP: true
            }))
          })
        })]
      }, node.id);
    })]
  });
};

List.defaultProps = {
  displayEditorial: false,
  inlineHeader: null,
  gridLayout: null
};
List.propTypes = {
  inlineHeader: PropTypes.oneOfType([PropTypes.shape({
    componentType: PropTypes.string,
    component: PropTypes.string,
    description: PropTypes.string,
    displaySwatches: PropTypes.bool,
    gridLayout: PropTypes.bool,
    products: PropTypes.shape()
  }), PropTypes.bool]),
  isMobile: PropTypes.bool,
  displayEditorial: PropTypes.bool,
  gridLayout: PropTypes.bool,
  displaySwatches: PropTypes.bool.isRequired,
  products: PropTypes.shape().isRequired
};
export default List;